// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ProductRuleResponse

import { BookingRuleType } from './enums.gen';

export type ProductRuleApiResponse = {
	type: BookingRuleType.Product;
	productIds: Array<string> | null;
};

export type ProductRule = {
	type: BookingRuleType.Product;
	productIds: Array<string> | null;
};

export function hydrateProductRule(data: ProductRuleApiResponse): ProductRule {
	return { ...data };
}